.vendor-lead-step-address-tab__container {
  height: 100%;

  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: stretch;

  gap: 32px;

  padding: 24px 0 0;
}

.vendor-lead-step-address-tab__container .vendor-lead-step-address-tab__container__row {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

.vendor-lead-step-address-tab__container .vendor-lead-step-address-tab__container__subrow {
  width: 100%;

  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;

  gap: 16px;
}

@media screen and (width <= 640px) {
  .vendor-lead-step-address-tab__container {
    flex-flow: column nowrap;
    align-items: stretch;
  }

  .vendor-lead-step-address-tab__container .vendor-lead-step-address-tab__container__row {
    flex-flow: column nowrap;
    align-items: stretch;
  }
}
